import { CustomIcon } from '@/shared/components/Icon/CustomIcon'
import { pxToRem } from '@/shared/styles/themes'
import { styled } from '@mui/material'

export type OrderDetailsSidebarCollapseProps = {
  onClick: () => void
}

export const OrderDetailsSidebarCollapse: React.FC<OrderDetailsSidebarCollapseProps> = ({ onClick }) => {
  return (
    <StyledCollapsedContainer onClick={onClick}>
      <CustomIcon svg iconCode={'rightSidebarExpand'} width={pxToRem(16)} />
    </StyledCollapsedContainer>
  )
}

const StyledCollapsedContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: calc(100% - ${pxToRem(16)});
  width: ${pxToRem(30)};
  background-color: ${({ theme }) => theme.palette.custom.widgetButton.backgroundColor};
  margin: ${pxToRem(8)} 0 0 0;
  border-radius: ${pxToRem(8)} 0 0 ${pxToRem(8)};
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.20);
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
    background-color: ${({ theme }) => theme.palette.custom.widgetButton.hoverBackgroundColor};
  }
`